export default "__VITE_ASSET__PnhOtlMb__"